var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormControlLabel, Switch } from '@material-ui/core';
import { isBoolean } from '../../../utils';
const Container = styled('div') `
  padding: 12px 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  ${({ theme }) => `
    background-color: ${theme.palette.background};
    ${theme.breakpoints.down('sm')} {
      flex-direction: column;
      align-items: flex-start;
    }
  `}
`;
const StyledSwitch = styled(Switch) `
  margin: 0 11px 0 4px;
`;
const ChildrenContainer = styled('div') `
  display: flex;
  align-items: center;
  &:last-child {
    margin-left: auto;
  }
  ${({ theme }) => `
    ${theme.breakpoints.down('sm')} {
      margin-top: 12px;
    }
  `}
`;
const Controls = (_a) => {
    var { checked, children, onChange, switchLabel } = _a, rest = __rest(_a, ["checked", "children", "onChange", "switchLabel"]);
    const [localChecked, setLocalChecked] = useState(false);
    const onToggle = (event) => {
        onChange && onChange(event);
        if (!isBoolean(checked)) {
            setLocalChecked((localChecked) => !localChecked);
        }
    };
    return (React.createElement(Container, Object.assign({}, rest),
        onChange && (React.createElement(FormControlLabel, { control: React.createElement(StyledSwitch, { checked: isBoolean(checked) ? checked : localChecked, onChange: onToggle, color: "primary" }), label: switchLabel })),
        children && React.createElement(ChildrenContainer, null, children)));
};
Controls.displayName = 'CookiesConsent.Controls';
Controls.propTypes = {
    checked: PropTypes.bool,
    children: PropTypes.node,
    onChange: PropTypes.func,
    switchLabel: PropTypes.string,
};
const ControlsExtra = styled(Controls) ``;
export default ControlsExtra;
